import Div from 'src/components/atomic/atom/Div'
import { COLOR } from 'src/constants/colors'
import Section from 'src/components/atomic/atom/Section'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { ExplorerDataPropsType } from 'src/views/Service/Explorer/Main'
import { useTranslation } from 'react-i18next'

const ExplorerMainFileCategory = (props: { data: ExplorerDataPropsType }) => {
  const { ExplorerFileItems } = props.data
  const { t } = useTranslation()
  const { setMediaStyle } = useMediaQueryHook()
  return (
    <>
      <Span option={'title'} $margin={'16px 0 0 0'}>
        {t('EXPLORER.CATEGORY.TITLE', { defaultValue: 'Categories' })}
      </Span>
      <Div
        display={'grid'}
        $grid_template_columns={'repeat(3, 1fr)'}
        $gap={setMediaStyle('18px', '12px', '10px')}
        $margin={setMediaStyle('16px auto 32px auto', '16px auto 32px auto', '20px auto')}
      >
        {ExplorerFileItems.map((element) => (
          <Div
            key={element.name}
            className={element.className}
            $hover={COLOR.black4}
            $border_radius={'12px'}
            $bgColor={COLOR.black2}
            onClick={element.onClick}
            height={setMediaStyle('112px', '100px', '92px')}
          >
            <Section
              display={'flex'}
              $align_item={'center'}
              $border_radius={'100px'}
              $bgColor={element.bgColor}
              width={setMediaStyle('52px', '48px', '48px')}
              height={setMediaStyle('52px', '48px', '48px')}
              $margin={setMediaStyle(
                '18px auto 4px auto',
                '16px auto 2px auto',
                '10px auto 4px auto',
              )}
            >
              <Svg name={element.svg_name} $margin={'0 auto'} />
            </Section>
            <Span option={'tiny_bold'}>{element.name}</Span>
          </Div>
        ))}
      </Div>
    </>
  )
}
export default ExplorerMainFileCategory
